import {
  SET_USER,
  INCREMENT_PENDING_UPLOADS,
  DECREMENT_PENDING_UPLOADS,
  RESET_PENDING_UPLOADS,
  RELOAD_PENDING_UPLOADS,
  LOGOUT_USER
} from '../actions/types';

// 🔧 Helper per gestire localStorage per utente specifico
const getPendingUploadsKey = () => {
  try {
    const userId = localStorage.getItem('userId');
    if (userId) {
      const parsedUserId = JSON.parse(userId);
      return `pendingDocumentUploads_${parsedUserId}`;
    }
  } catch (e) {
    console.error('Error getting userId for pending uploads key:', e);
  }
  return 'pendingDocumentUploads_anonymous';
};

const getPendingUploadsFromStorage = () => {
  try {
    const key = getPendingUploadsKey();
    const stored = localStorage.getItem(key);
    return stored ? parseInt(stored, 10) : 0;
  } catch (e) {
    console.error('Error reading pendingDocumentUploads from localStorage:', e);
    return 0;
  }
};

const setPendingUploadsToStorage = (count) => {
  try {
    const key = getPendingUploadsKey();
    localStorage.setItem(key, count.toString());
  } catch (e) {
    console.error('Error writing pendingDocumentUploads to localStorage:', e);
  }
};

// Inizializza da localStorage
const initialState = {
  user: null,
  pendingDocumentUploads: getPendingUploadsFromStorage(), // Recupera da localStorage
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER: {
      // Quando viene settato l'utente, ricarica il pending counter per quell'utente
      const reloadedCount = getPendingUploadsFromStorage();
      return {
        ...state,
        user: action.payload,
        pendingDocumentUploads: reloadedCount,
      };
    }
    case INCREMENT_PENDING_UPLOADS: {
      const newCount = state.pendingDocumentUploads + 1;
      setPendingUploadsToStorage(newCount);
      console.log(`📊 Pending uploads incrementato: ${newCount}`);
      return {
        ...state,
        pendingDocumentUploads: newCount,
      };
    }
    case DECREMENT_PENDING_UPLOADS: {
      const newCount = Math.max(0, state.pendingDocumentUploads - 1);
      setPendingUploadsToStorage(newCount);
      console.log(`📊 Pending uploads decrementato: ${newCount}`);
      return {
        ...state,
        pendingDocumentUploads: newCount,
      };
    }
    case RESET_PENDING_UPLOADS: {
      setPendingUploadsToStorage(0);
      console.log('📊 Pending uploads resettato: 0');
      return {
        ...state,
        pendingDocumentUploads: 0,
      };
    }
    case RELOAD_PENDING_UPLOADS: {
      // Ricarica il contatore da localStorage (utile dopo login/set user)
      const reloadedCount = getPendingUploadsFromStorage();
      console.log(`📊 Pending uploads ricaricato da localStorage: ${reloadedCount}`);
      return {
        ...state,
        pendingDocumentUploads: reloadedCount,
      };
    }
    case LOGOUT_USER: {
      // Reset pending uploads al logout
      setPendingUploadsToStorage(0);
      console.log('📊 Pending uploads resettato al logout');
      return {
        ...state,
        user: null,
        pendingDocumentUploads: 0,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
